export default __webpack_public_path__ + "static/media/flagOfIsrael.6178bcc3.svg";